export const authExchangeApi = (data: any) => {
  const { post } = useUseRequest()
  return post('/auth/exchange', data)
}

export const logoutApi = () => {
  const { post } = useUseRequest()
  return post('/logout')
}

// export const getUserCompanyInfoApi = () => {
//   const { post } = useUseRequest()
//   return post('/auth/userCompany')
// }
/**
 * 登陆改造 2025-08-21 15:13:13
 * @returns
 */
export const getUserCompanyInfoApi = () => {
  const { post } = useUseRequest()
  return post('/auth/userCompPerms')
}

export const getCompanyInfoApi = (data: any) => {
  const { post } = useUseRequest()
  return post('/auth/company', data)
}
export const getUserInfoApi = (data: any) => {
  const { post } = useUseRequest()
  return post('/auth/user', data)
}

export const getPermsApi = () => {
  const { post } = useUseRequest()
  return post(`/auth/perms`, { sysId: getAppId() })
}

export function getJoinCompanyApi(data = {}) {
  const { post } = useUseRequest()
  return post(`/auth/getJoinCompany`, { method: 'post', data })
}

/**
 * @description: 客服中心-验证商铺指定客服(用户后台)
 * @return {*}
 */
export const toOpenCcCenterApi = (data: any) => {
  const { post } = useUseRequest()

  return post(`/ics/tenant/fr/session/openCcCenter`, data)
}
/**
 *
 * @param data {event_type:'xx',context:{ad:{callback:''}},timestamp: new Date().getTime(),}
 * @returns
 */
export const dyReport = (data: any) => {
  const { post } = useUseRequest()
  return post(`https://analytics.oceanengine.com/api/v2/conversion`, data)
}
export const reportApi = (data: any, headers: any) => {
  const { post } = useUseRequest()

  if (data.extensions) {
    // 获取所有非ERA_开头的键并更新它们的键名
    Object.keys(data.extensions).forEach((key) => {
      if (!key.startsWith('MPERA_')) {
        const newKey = `MPERA_${key}`
        data.extensions[newKey] = data.extensions[key]
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete data.extensions[key]
      }
    })
  }
  if (isDev()) {
    console.warn('本地环境埋点', data, headers)
    return new Promise((resolve) => {
      resolve({ data, headers })
    })
  }

  return post(`/tracking/report`, data, {}, { headers })
}

export const reportCallBack = (
  data: any,
  pageCode: any,
  operationType = 'EVENT',
) => {
  const { eventCode, extensions } = data
  const reportData = {
    eventCode,
    extensions,
  }
  const reportHeaders = {
    'operation-timestamp': new Date().getTime(), // 客户端的当前时间的时间戳
    'operation-stay': 0,
    'operation-type': operationType || 'EVENT',
    'page-code': pageCode || 'PAGE-CODE-IS-NULL',
  }
  return new Promise((resolve, reject) => {
    reportApi(reportData, reportHeaders)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => reject(error))
  })
}

export const pageRedirectApi = (data: any) => {
  const { post } = useUseRequest()
  return post('/auth/redirect', data)
}

/**
 * 获取公司联系人信息
 * @param data  公司id  {id: 3123123123}
 * @returns
 */
export const getMainStaffApi = (data: any) => {
  const { post } = useUseRequest()
  return post('/hzh/fr/shops/getMainStaff', data)
}

/**
 * @description: 获取字典数据
 * @param {String} type
 * @return {Object}
 */
export const getSystemType = (type: string) => {
  const { post } = useUseRequest()
  return post(`/system/admin/dict/data/type/dictType`, {
    dictType: type,
  })
}
